import { $api } from "@/services/api";

const state = {
  products: [],
  totalProductRecords: null,
  likedProducts: [],
  categories: [],
  selectedProduct: {},
  compare: [],
  searchQuery: "",
  pageStates: {
    catalog: { page: 1, branchCode: null },
    editCatalog: { page: 1, branchCode: null },
  },
};
const getters = {
  products: (state) => state.products,
  likedProducts: (state) => state.likedProducts,
  categories: (state) => state.categories,
  selectedProduct: (state) =>
    Object.keys(state.selectedProduct).length
      ? state.selectedProduct
      : JSON.parse(sessionStorage.getItem("selectedProduct")),
  compare: (state) => state.compare,
  searchQuery: (state) => state.searchQuery,
  totalProductRecords: (state) => state.totalProductRecords,
  pageState: (state) => (key) => state.pageStates[key] ?? { page: 1, branchCode: null },
};

const mutations = {
  setLikedProducts(state, likedProducts) {
    state.likedProducts = likedProducts;
  },
  sortComparedProducts(state, params) {
    state.compare = state.compare.sort((a, b) => {
      if (params.isDesc) {
        return a[params.sortBy] < b[params.sortBy] ? 1 : -1;
      } else {
        return a[params.sortBy] > b[params.sortBy] ? 1 : -1;
      }
    });
  },
  setProducts(state, products) {
    state.products = products;
  },
  setCategories(state, category) {
    state.categories = category;
  },
  updateSearchQuery(state, data) {
    state.searchQuery = data;
  },
  updateSelectedProduct(state, item) {
    if (sessionStorage.getItem("selectedProduct")) {
      sessionStorage.removeItem("selectedProduct");
      sessionStorage.setItem("selectedProduct", JSON.stringify(item));
      state.selectedProduct = item;
    } else {
      sessionStorage.setItem("selectedProduct", JSON.stringify(item));
      state.selectedProduct = item;
    }
  },
  async addItemToCompare(state, product) {
    const addedCompareItems = state.compare.find((comparedProduct) => {
      return comparedProduct.catalog_item_id === product.catalog_item_id;
    });
    if (!addedCompareItems) {
      if (state.compare.length < 6) {
        let productDetail =
          await $api.m_v_product_details.get({
            catalog_item_id: product.catalog_item_id
          });
        // const { data: image } = await $api.v_product_media.getProductMedia(
        //   product.catalog_item_id
        // );
        // state.compare.push({ ...productDetail[0], ...image[0] });

        state.compare.push({ ...productDetail[0] });
      } else {
        //...
      }
    } else {
      state.compare = state.compare.filter((comparedProduct) => {
        return comparedProduct.catalog_item_id !== product.catalog_item_id;
      });
    }
  },
  removeItemFromCompare(state, id) {
    state.compare = state.compare.filter(
      (product) => product.catalog_item_id !== id
    );
  },
  clearComparedProducts(state) {
    state.compare = [];
  },
  clearLikedProducts(state) {
    state.likedProducts = [];
  },
  clearProducts(state) {
    state.products = [];
  },
  clearCategories(state) {
    state.categories = [];
  },
  setTotalProductRecords(state, totalProductRecords) {
    state.totalProductRecords = totalProductRecords;
  },
  clearTotalProductRecords(state) {
    state.totalProductRecords = null;
  },
  setPageState(state, { key, page, branchCode }) {
    state.pageStates[key] = { page: page ?? 1, branchCode: branchCode ?? null };
  },
  clearPageState(state, key) {
    state.pageStates[key] = { page: 1, branchCode: null };
  },
  clearSelectedProduct(state) {
    state.selectedProduct = {};
  },
};

const actions = {
  async saveLikedProduct({ state }, payload) {
    await $api.m_product_favorites.saveFavoriteProduct(payload);
    state.likedProducts.push({
      ...payload
    });
  },
  async removeLikedProduct({ state }, payload) {
    const { data: likedProduct } =
      await $api.m_product_favorites.findFavoriteProduct(
        payload.user_id,
        payload.branch_code,
        payload.catalog_item_id
      );
    await $api.m_product_favorites.removeFavoriteProductById(likedProduct[0].id);
    state.likedProducts = state.likedProducts.filter(
      (likedProduct) => likedProduct.catalog_item_id !== payload.catalog_item_id
    );
  },
  async filterProductsWithPagination({ commit }, params) {
    const response = await $api.m_v_product_categories.filterProductsWithPagination(
      params
    );
    if (response && response.status == 200) {
      commit("setProducts", response.data.data);
      commit("setTotalProductRecords", response.data.total); // set total products length for pagination
    }
  },

  async filterAllProductsWithPagination({ commit }, params) {
    const response =
      await $api.m_v_product_categories.filterAllProductsWithPagination(params);
    if (response && response.status == 200) {
      commit("setProducts", response.data.data);
      commit("setTotalProductRecords", response.data.total); // set total products length for pagination
    }
  },

  async filterFavoriteProductsWithPagination({ commit }, params) {
    const response =
      await $api.m_product_favorites.filterFavoriteProductsWithPagination(
        params
      );
    if (response && response.status == 200) {
      commit("setLikedProducts", response.data.data);
      commit("setTotalProductRecords", response.data.total); // set total products length for pagination
    }
  },

  async filterRecentlyViewProductsWithPagination({ commit }, params) {
    const response =
      await $api.m_product_recently_views.filterRecentlyViewProductsWithPagination(
        params
      );
    if (response && response.status == 200) {
      commit("setProducts", response.data.data);
      commit("setTotalProductRecords", response.data.total); // set total products length for pagination
    }
  },

  // async filterRecentlyPurchaseProductsWithPagination({ commit }, params) {
  //   const response =
  //     await $api.v_product_recently_purchase.filterRecentlyPurchaseProductsWithPagination(
  //       params
  //     );
  //   if (response && response.status == 200) {
  //     commit("setProducts", response.data);
  //     commit("setTotalProductRecords", response.headers["x-total-count"]); // set total products length for pagination
  //   }
  // },

  async filterSearchProductsWithPagination({ commit }, params) {
    const { includeExpired = false, ...requestParams } = params;

    let activeResponse = { products: [], total: 0 };

    try {
      activeResponse =
        await $api.m_v_product_categories.filterSearchProductsWithPagination(
          requestParams
        );
    } catch (error) {
      console.error(error);
    }

    const activeProducts = activeResponse?.products || [];
    const activeTotal = activeResponse?.total || 0;

    if (!includeExpired) {
      commit("setProducts", activeProducts);
      commit("setTotalProductRecords", activeTotal);
      return;
    }

    const baseSkip = requestParams.skip || 0;
    const baseLimit = requestParams.limit || 0;

    const needsExpiredData =
      baseSkip >= activeTotal || activeProducts.length < baseLimit;

    let expiredSkip = 0;
    let expiredLimit = 0;

    if (baseSkip >= activeTotal) {
      expiredSkip = baseSkip - activeTotal;
      expiredLimit = baseLimit;
    } else {
      const remaining = baseLimit - activeProducts.length;
      if (remaining > 0) {
        expiredLimit = remaining;
      }
    }

    const expiredRequestLimit = needsExpiredData
      ? expiredLimit || baseLimit
      : 1;

    const expiredParams = {
      ...requestParams,
      skip: expiredSkip,
      limit: expiredRequestLimit,
    };

    let expiredResponse = { products: [], total: 0 };

    try {
      expiredResponse =
        await $api.m_v_product_categories_expired.filterSearchExpiredProductsWithPagination(
          expiredParams
        );
    } catch (error) {
      console.error(error);
    }

    const expiredTotal = expiredResponse?.total || 0;
    const expiredProducts =
      expiredLimit > 0
        ? (expiredResponse?.products || [])
            .slice(0, expiredLimit)
            .map((item) => ({
              ...item,
              isExpired: true,
            }))
        : [];

    const mergedProducts = [...activeProducts, ...expiredProducts].slice(
      0,
      baseLimit
    );

    commit("setProducts", mergedProducts);
    commit("setTotalProductRecords", activeTotal + expiredTotal); // set total products length for pagination

  },

  async getFavoriteProducts({ commit }, params) {
    try {
      const response = await $api.m_product_favorites.getFavoriteProducts(params);
      if (response && response.status == 200) {
        commit("setLikedProducts", response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  },
  sortComparedProducts({ commit }, params) {
    commit("sortComparedProducts", params);
  },
  updateSelectedProduct({ commit }, item) {
    commit("updateSelectedProduct", item);
  },
  addItemToCompare({ commit }, item) {
    commit("addItemToCompare", item);
  },
  removeItemFromCompare({ commit }, id) {
    commit("removeItemFromCompare", id);
  },
  clearComparedProducts({ commit }) {
    commit("clearComparedProducts");
  },
  updateSearchQuery({ commit }, data) {
    commit("updateSearchQuery", data);
  },
  clearLikedProducts({ commit }) {
    commit("clearLikedProducts");
  },
  clearProducts({ commit }) {
    commit("clearProducts");
  },
  clearCategories({ commit }) {
    commit("clearCategories");
  },
  clearTotalProductRecords({ commit }) {
    commit("clearTotalProductRecords");
  },
  savePageState({ commit }, { key, page, branchCode }) {
    commit("setPageState", { key, page, branchCode });
  },
  clearPageState({ commit }, key) {
    commit("clearPageState", key);
  },
  clearSelectedProduct({ commit }) {
    commit("clearSelectedProduct");
  },
};

export default { state, getters, mutations, actions };
